export default "/assets/images/mila-room-showcase-sm-03.webp?fac84dea673ea0beb10dee74f56471c8";